export const environment = {
  production: true,
  baseHref: '/',
  dxtBaseHref: '/app/forms/mu3/',
  dxtOrigin: 'https://gateway-qaint.qa.finra.org',
  gatewayOrigin: 'https://gateway-qaint.qa.statemortgageregistry.com',
  dxtBasePath: '/app',
  formName: 'MU3 Form',
  env: 'qaint',
  ags: 'MLSMOD',
  identityProviderRealm: 'isso' as 'ews' | 'isso',
  issoRoles: [],
  ewsRoles: [],
  activateBeast: false,
  mockHostApi: false,
  attachmentsTemplate: 'attachments-qaint',
  identity: 'https://identity-int.qa.statemortgageregistry.com',
  logout: 'https://login-int.qa.statemortgageregistry.com/logout',
  urls: {
    datacollection: 'https://datacollection-int.qa.statemortgageregistry.com',
    entityProfileGraphql: 'https://entityprofile-int.qa.statemortgageregistry.com/profile',
    dataServicesGraphql: 'https://dataservices-int.qa.statemortgageregistry.com/api',
    dataServices: 'https://dataservices-int.qa.statemortgageregistry.com',
    individualSummary: '{{individualSummary}}',
    cloudwell: 'https://csbsannualrenewalchecklist-dev.azurewebsites.net',
    csbsChecklist: 'https://csbsannualrenewalchecklist-dev.azurewebsites.net',
    fist: 'https://filestorage-int.qa.statemortgageregistry.com',
    apiReference: 'https://reference-int.qa.statemortgageregistry.com',
    mortgageLicensingSystem: 'https://qa.mortgage.nationwidelicensingsystem.org',
    origin: 'https://mu3-form-int.qa.statemortgageregistry.com',
    classicNmlsState: 'https://state-qa5.qa.statemortgageregistry.com',
    addressLookup: 'https://address-validation-int.qa.statemortgageregistry.com',
  },
  defaultRoute: ['view', 'dataEntry', 'section', 'identifyingInformation'],
  currentVersion: '0.0.1',
  versions: {
    '0.0.1': {
      urls: {
        // @mu3-todo(verify-upstream): Old centralized schema URLs — remove after embedded schema approach is verified
        // schema: '{{schemaUrl}}/0.0.1/root.schema.json',
        // schemasBase: '{{schemaUrl}}/0.0.1',
        // layoutsBase: '{{layoutsUrl}}/0.0.1',
        // layoutTemplates: ['{{layoutsUrl}}/0.0.1/layout-templates.json'],
        schema: 'https://mu3-form-int.qa.statemortgageregistry.com/assets/schemas/models/0.0.1/root.schema.json',
        schemasBase: 'https://mu3-form-int.qa.statemortgageregistry.com/assets/schemas/models/0.0.1',
        layoutsBase: 'https://mu3-form-int.qa.statemortgageregistry.com/assets/schemas/layouts/0.0.1',
        layoutTemplates: ['https://mu3-form-int.qa.statemortgageregistry.com/assets/schemas/layouts/0.0.1/layout-templates.json'],
        individualProfile: 'https://gateway-qaint.qa.statemortgageregistry.com/app/entity-profile/individual-profile',
        invoiceInfoUrl: 'https://state-qa5.qa.statemortgageregistry.com/Home/Invoice/InvoiceInfo.aspx?InvoiceId',
        workManagement: 'https://gateway-qaint.qa.statemortgageregistry.com/app/work-management',
        taskManagement: 'https://gateway-qaint.qa.statemortgageregistry.com/app/task-management',
      },
      template: {
        name: 'mu3-qaint',
        namespace: 'nmls',
        version: '0.0.1',
      },
      extensions: {
        create: {
          name: 'create-mu3',
          version: '0.0.1',
          namespace: 'nmls',
        },
      },
    },
  },
};

export type Versions = keyof typeof environment.versions;
